import { Loader } from "@googlemaps/js-api-loader";
const url = "https://maps.googleapis.com/maps/api/staticmap";

export class EC1Map {
    map;
    center;
    circle;
    svgMarker;
    marker;
    polygons = [];
    infoWindow;
    geocoder;

    initializeMap(mapsApiKey) {
        const loader = new Loader({
            apiKey: mapsApiKey,
            version: "weekly",
        });

        loader.load().then(async () => {
            const { Map } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

            this.AdvancedMarkerElement = AdvancedMarkerElement;
            this.PinElement = PinElement;

            this.infoWindow = new window.google.maps.InfoWindow({
                content: "0.0",
                zIndex: 1,
            });
            var latlng = new google.maps.LatLng(46.604762, 2.464154);
            var options = {
                zoom: window.screen.width >= 1536 ? 6 : 5,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                disableDefaultUI: true,
                mapTypeControl: window.screen.width > 950 ? true : false,
                mapTypeControlOptions:
                {
                    position: google.maps.ControlPosition.TOP_RIGHT,
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                },
                mapId: 'ec1-map' // Required for AdvancedMarkerElement
            };
            let el = document.getElementById("map1");
            if (el) {
                this.map = new Map(el, options);

                // Hide splash screen immediately after map creation
                // (Google Maps events don't fire reliably when modal covers the map)
                let splashScreenHidden = false;
                const hideSplashScreen = async () => {
                    if (splashScreenHidden) return;
                    splashScreenHidden = true;
                    try {
                        if (window.MapDotNetHelper) {
                            await window.MapDotNetHelper.invokeMethodAsync('DisplaySplashScreen', false);
                        }
                    } catch (error) {
                        console.error('Error hiding splash screen:', error);
                    }
                };

                // Hide immediately after map is created
                hideSplashScreen();

                // Very short fallback timeout as final safety net
                setTimeout(() => {
                    if (!splashScreenHidden) {
                        hideSplashScreen();
                    }
                }, 100);

                this.map.addListener("click", async (ev) => {
                    this.ClearObjectsFromMap();
                    var loc = document.getElementById('localisation');
                    if (loc) {
                        var local = ev.latLng.lat().toFixed(6) + ',' + ev.latLng.lng().toFixed(6);
                        if (window.dotNetHelper) {
                            await window.dotNetHelper.invokeMethodAsync('ValidateLocalization', local, false);
                            await window.dotNetHelper.invokeMethodAsync("ResetComputation", +ev.latLng.lat().toFixed(6), +ev.latLng.lng().toFixed(6));
                            if (window.OverlayDotNetHelper) {
                                await window.OverlayDotNetHelper.invokeMethodAsync("UpdateResultsVisibility");
                            }
                        }
                    }
                })
                window.gmap = this.map;
            }
        }).catch((error) => {
            console.error('Error loading Google Maps:', error);
            // Hide splash screen even if map fails to load
            if (window.MapDotNetHelper) {
                window.MapDotNetHelper.invokeMethodAsync('DisplaySplashScreen', false);
            }
        });
    }

    SetPosition(latitude, longitude, reposition = true) {
        try {
            this.ClearPolygons();
            this.center = new google.maps.LatLng(latitude, longitude);
            this.AddCircle(this.center);
            this.AddMarker(this.center);
            hideLegendBlock();

            if (reposition) {
                this.SetCenter();
                this.ZoomOnCircle();
            }
        } catch (error) {
            console.error(error);
        }
    }

    SetMarkerOnly(latitude, longitude, reposition = true) {
        try {
            this.ClearPolygons();
            this.center = new google.maps.LatLng(latitude, longitude);
            this.AddMarker(this.center);
            hideLegendBlock();

            if (reposition) {
                this.SetCenter();
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    AddCircleToExistingMarker(shouldZoom = true) {
        try {
            if (this.center) {
                this.AddCircle(this.center);
                if (shouldZoom) {
                    this.ZoomOnCircle();
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    SetCountryZoom(latitude, longitude, zoomLevel) {
        if (window.gmap) {
            this.center = new google.maps.LatLng(latitude, longitude);
            this.SetCenter();    

            if (!zoomLevel) {
                var zoomLevel = 8;
            }
            window.gmap.setZoom(zoomLevel);
        }
    }

    SetCenter() {
        if (this.center && window.gmap) {
            if (window.innerWidth > 950) {
                window.gmap.setCenter(this.center);
            }

        }
    }

    AddCircle(latlng) {
        if (!this.circle) {
            this.circle = new google.maps.Circle({
                radius: this.getRadius(),
                strokeColor: "#fd7e14",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: "#D0CCCC",
                fillOpacity: 0,
                map: window.gmap,
                center: latlng,
                zindex: 60,
                clickable: false
            });
        } else {
            this.circle.setMap(null);
            this.circle.setOptions({
                radius: this.getRadius(),
                strokeColor: "#fd7e14",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: "#D0CCCC",
                fillOpacity: 0,
                map: window.gmap,
                center: latlng,
                zindex: 60,
                clickable: false
            });
        }
    }

    AddMarker(latlng) {
        if (!this.marker) {
            // Create a custom pin with orange color
            const pinElement = new this.PinElement({
                background: "#fd7e14",
                borderColor: "#000000",
                glyphColor: "#ffffff",
            });

            this.marker = new this.AdvancedMarkerElement({
                position: latlng,
                map: window.gmap,
                content: pinElement.element,
            });
        } else {
            this.marker.position = latlng;
            this.marker.map = window.gmap;
        }
    }
       
    ZoomOnCircle() {
        if (this.circle) {
            let circle_Bounds = this.circle.getBounds();
            this.map.fitBounds(circle_Bounds);
        }
    }

    UpdateRadius() {
        if (this.circle) {
            this.circle.setRadius(this.getRadius());
        }
    }

    ClearObjectsFromMap() {
        if (this.marker) {
            this.marker.map = null;
        }
        this.circle?.setMap(null);
        this.ClearPolygons();
    }

    ClearPolygons() {
        for (let polygon of this.polygons) {
            polygon.setMap(null);
            window.google.maps.event.clearInstanceListeners(polygon);
            window.google.maps.event.clearListeners(polygon, 'click');

        }
        this.polygons = [];
    }

    ZoomIn() {
        if (window.gmap) {
            var currentZoomLevel = window.gmap.getZoom();
            if (currentZoomLevel != 21) {
                window.gmap.setZoom(currentZoomLevel + 0.5);
            }
        }
    }

    ZoomOut() {
        if (window.gmap) {
            var currentZoomLevel = window.gmap.getZoom();
            if (currentZoomLevel != 0) {
                window.gmap.setZoom(currentZoomLevel - 1);
            }
        }
    }
    
    ManageZoomLevel(zoomable) {
        if (window.gmap) {
            window.gmap.setOptions(
                {
                    scrollwheel: zoomable,
                    disableDoubleClickZoom: zoomable,
                    draggable: zoomable,

                });

            if (window.OverlayDotNetHelper) {
                window.OverlayDotNetHelper.invokeMethodAsync("UpdateResultsVisibility");
            }

            if (window.ResultsDotNetHelper) {
                window.ResultsDotNetHelper.invokeMethodAsync("UpdateResultsPanel");
            }

            if (window.EchartsDotNetHelper) {
                window.EchartsDotNetHelper.invokeMethodAsync("UpdateEchartsComponent");
            }
        }
    }

    AddSectors(slices) {
        this.ClearPolygons();

        for (let slice of slices) {

            let paths = this.getArcPath(this.center, this.getRadius(), slice.startAngle, slice.endAngle);
            paths?.splice(0, 0, this.map.getCenter());

            let polygon = new window.google.maps.Polygon(
                {
                    paths: paths,
                    strokeColor: "#000000",
                    strokeOpacity: 0.9,
                    strokeWeight: 2,
                    fillColor: slice.color,
                    fillOpacity: 0.3,
                    zIndex: 61,
                    map: this.map,
                    editable: false,
                    clickable: true
                });

            let path = polygon.getPath().getArray();
            let center_lat = (Math.max(...path.map(x => x.lat())) + Math.min(...path.map(x => x.lat()))) / 2;
            let center_lng = (Math.max(...path.map(x => x.lng())) + Math.min(...path.map(x => x.lng()))) / 2;
            let centerjs = new google.maps.LatLng(center_lat, center_lng);

            this.polygons.push(polygon);

            polygon.addListener("mouseover", function () {
                var speedValue = window.EC1.MapService.GetFormattedRugoValue(slice.rugo);
                var text =
                    `<div class=\"infowindow__content\"> <p><i>c</i><sub>dir</sub> = ${slice?.coeffDir} <br /></p> <i>z</i><sub>0</sub> = ${speedValue}</div>`;


                if (window.EC1.MapService.infoWindow != null) {
                    window.EC1.MapService.infoWindow?.setPosition(centerjs);
                    window.EC1.MapService.infoWindow?.setContent(text);

                    window.EC1.MapService.infoWindow?.open(window.gmap);

                }
            });

            window.google.maps.event.addListener(polygon, "mouseout", function () {
                window.EC1.MapService.infoWindow?.close();
            });

        }

        var circleOptions = {
            strokeColor: "#000000",
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: "#D0CCCC",
            fillOpacity: 0, //0.3f
        };
        this.circle?.setMap(null);
        this.circle?.setOptions(circleOptions);
        this.circle?.setMap(this.map);
        if (this.marker) {
            this.marker.map = null;
        }

        if (window.innerWidth <= 950 && window.screen.orientation.type == 'landscape-primary') {
            this.map.panBy(-250, 0);
        }

    };

    UpdateResultsVisibility() {
        if (window.OverlayDotNetHelper) {
            window.OverlayDotNetHelper.invokeMethodAsync("UpdateResultsVisibility");
        }
    }

    GetFormattedRugoValue(speed) {
        try {

            if (speed >= 10) return Math.round(speed).toString() + " cm";
            else if (speed >= 1 && speed < 10) return speed.toFixed(1) + " cm";
            else if (speed < 1) return Math.round(speed * 10).toString() + " mm";
            else {
                return "";
            }

        }
        catch {
             return "";
        }
    };



    getArcPath(center, radiusMeters, startAngle, endAngle) {
        try {
            var point;
            var points = Array();
            var a = startAngle;

            while (true) {
                point = window.google.maps.geometry.spherical.computeOffset(center, radiusMeters, a);
                points.push(point);
                if (a == endAngle) {
                    break;
                }
                a++;
                if (a > 360) {
                    a = 1;
                }
            }

            return points;
        }
        catch (error) {
            console.error(error);
        }
    };

    async getLocation(address) {
        try {
            // Validate address before geocoding
            if (!address || address.trim() === '') {
                console.error('Invalid address provided to getLocation:', address);
                return null;
            }

            this.geocoder = new window.google.maps.Geocoder();
            const numberRegex = "((\\-?|\\+?)?\\d+(\\.\\d+)?)";
            const regexLatLong = new RegExp(`^(${numberRegex})\\s*,?\\s*(${numberRegex})$`, "gi");

            // Check if input is already coordinates (lat,lng format)
            if (regexLatLong.test(address.trim())) {
                var latLong = address.match(new RegExp(numberRegex, "gi"));
                return {
                    Latitude: Number(latLong[0]),
                    Longitude: Number(latLong[1]),
                    Country: '',
                    Status: true
                }
            }

            // Geocode address to coordinates using Google Maps
            let geoCodeObj = { 'address': address };
            const { results, status } = await this.geocoder.geocode(geoCodeObj);

            if (results && Array.isArray(results) && results.length > 0) {
                return {
                    Latitude: results[0].geometry.location.lat(),
                    Longitude: results[0].geometry.location.lng(),
                    Country: results[0].address_components.find(c => c.types.includes('country'))?.short_name || '',
                    Status: true
                }
            }

            throw new Error('Geocoding failed: no results');

        } catch (ex) {
            console.log('Geocoding error:', ex);
            return {
                Latitude: 48.864716,
                Longitude: 2.349014,
                Country: '',
                Status: false
            };
        }
    }

    getRadius() {
        var height = document.getElementById('height').valueAsNumber;
        return Math.min(Math.max(23 * Math.pow(height, 1.2), 300), 5777);
    }
}
